
const mouseEnterTarget = Array.from(document.querySelectorAll('.js-mouseEntry-item'));
const windowWidth = window.innerWidth;

//サブメニューを取得
const childMenu = Array.from(document.querySelectorAll('.js-inner-child'));
//サブメニューの親を取得
let getParent = (targets) => {
    let parentElement = [];
    targets.map((target) => {
        parentElement.push(target.parentNode);
    })
    return parentElement;
}
const parents = getParent(childMenu);
parents.forEach((parent) => {
    let title = parent.querySelector('.js-category-title');
    title.classList.add('is-children');
});


// サブメニューを開閉
//768px以上の場合はマウスオーバーで開閉、768px以下の場合はクリックで開閉
if (windowWidth > 768) {
    if (mouseEnterTarget) {
        mouseEnterTarget.forEach((item) => {
            item.addEventListener('mouseenter', () => {
                item.classList.add('is-open');
            });
            item.addEventListener('mouseleave', () => {
                item.classList.remove('is-open');
            });
        });
    }
} else {
    if (mouseEnterTarget) {
        parents.forEach((parent) => {
            let title = parent.querySelector('a');
            title.style.pointerEvents = 'none';
        });
        mouseEnterTarget.forEach((item) => {
            item.addEventListener('click', () => {
                item.classList.toggle('is-open');
            });
        });
    }
}